<template>
  <!-- mt-2 -->
  <section class="notice-to-customers mt-2">
    <b-card class="mb-0">
      <h1>客戶須知</h1>
      <div class="notice-box">
        <h4>條款及細則</h4>
        <ul class="dashed">
          <li>
            『永發設計工程有限公司』 (WING FAT DESIGN CONTRACTING LIMITED)是多元化”室內設計”公司(以下簡稱為「我們」或「本司」)，為不同層面客戶提供室內設計、
傢俬訂制、設計 / 產品零售、室內外工程及產品配套等的代理或承辦商。同時並為香港屋宇署註冊小型工程承建商及機電工程署註冊電業承辦商。
          </li>
        </ul>
      </div>
      <div class="notice-box">
        <h4>貨品及服務銷售一般條款</h4>
        <ul class="dashed">
          <li>
            <b
              >此乃一般銷售條款，每類或個別貨品及服務可能另有其他條款及責任細則，客戶必須注意客戶需知，為保障客戶利益；如客戶對惠顧相關項目或服務有任何疑
問，請在確認單據或生產圖文前向職員查詢內容，本司會詳細說明其產品、項目和服務、備註、各施工方式衍生完工效果及條款細則。</b
            >
          </li>
          <li>
            客戶同意本公司配製工程單位鎖匙(如需要)並授權本公司相關工種工程師傅可以順利進入施工單位，並接受本司相關工種師傅進場時段安排及慣常施工方案施工。
若有特別情況或做法，客戶需在工程展開前或報價階段時向本司陳述。當完工後除更換施工單位鎖鑰外，原裝鎖鑰將交還客戶，已配製鎖匙也不作保留及銷毀。
          </li>
          <li>
            本司”工程地址”定義為客戶的享用服務及產品物料地址，涉及生產中工程項目”工程地址”本司不設更改。
          </li>
          <li>
            項目生產限制涉及影響結構、安全、保養、違法、公眾第三者及不可行生產，本司保留停止或修正改動生產之最終權利。
          </li>
          <li>
            倘若由於「不可抗力」的原因(包括由於火災、不幸事故、意外、天災、自然災禍、香港特別行政區政府或其任何政府機構的任何法律、命令、文告、條例、要求
或規定、罷工、勞資糾紛、勞工短缺或技術工人短缺、貨品或原材料短缺、運輸延誤或本司在合理範圍內無法控制的原因(無論是否與前述相似)，致使本司無法履
行其在本司網頁內的責任、保證及條款，本司可在受影響的範圍內豁免及無需履行該等責任、保證及條款。
          </li>
          <li>
            本司工作天計算為每週五個工作天、時間早上九時至下午六時及公眾假期休息。若遇八號風球、黑色暴雨、運輸扣關、物料供應（如缺貨）、客戶施工決定、未依
時階段付款、新增工程項目、施工期內任何已完成項目的執修或不可抗力原因（如示威堵路），倘若遇上以上原因，完工日期將自動以 7 個工作天為基礎自動順延。
          </li>
        </ul>
      </div>
      <div class="notice-box">
        <h4>財物與款項</h4>
        <ul class="dashed">
          <li>
            本司銷售憑據為經客戶確認簽署”銷售發票”或 ” 維修發票”當繳付訂金，所有經確認”銷售發票”或 ” 維修發票”雙方視為銷售合約(簡稱為銷售憑據)地
位，銷售憑據一式兩份經雙方確認及簽署各持一份履行(包括憑據背面)內容及保存憑據，經確認”銷售憑據”即表示客戶經己閱讀條款及細則，包括本法定通告和
免責聲明，並且不可撤回和無條件地接納及同意受其約束。
          </li>
          <li>
            如施工工程地址需要支付裝修按金，客戶須自行支付，本公司不設代支。若管理公司要求公眾地方需進行地台或電梯保護，將會衍生額外收費。
          </li>
          <li>
            本司設分階段收費即項目或服務進展至指定程度，給予客戶確認後須為該階段付款，屆時本公司均會另發收據。客戶請按階段付款，為免影響下一階段施工進度
安排，請依時按階段付款。若未能付款本司將自動廷後完工日期。如要求在施工期間執修指定項目，執修時間不包括原定的預計完工日期內，原定預計完工日將自
動延期或更新預計完工時間。本司將在工程完結後與客戶驗收後，由本司安排或由客戶提供時間進行執修相關產品，執修完成後將以基本保養(除註有)服務辦理。
          </li>
          <li>
            本司將於階段項目預計完工前的壹週內會以電話或通訊軟件通知客戶付款，確認並繳付相關之款項後，將安排下一階段施工準備。客戶一方相關之逾期、超越階
段或停工達到四週客戶需即時繳付全宗”銷售憑據”餘款，及後未能送貨項目會以該金額的 15%作為每月存倉費，及逾期三個月本司視為客戶一方放棄項目物品
棄置處理，客戶需繳付上述之逾期費用。
          </li>
          <li>
            於施工單位內客戶需自行保管及妥存於單位內個人財物，情況許可下請搬離該財物。施工期間本司不能給予該財物或裝置安全或運作。客戶可透過保險或額外保
護保護財物、裝置及自備建材物品，如經證實本司損毀客戶之物品每單最高賠為港幣二佰元內(不涉及第三者保險)，如有失竊報警求助。任何情況下未繳清貨款總
額，產品擁有權仍屬本司，及即時中止所有保險、完工証明及所有售後服務。並保留追收已承造項目或服務貨款，已經進行中或已安排項目，將不可退訂或取消。
          </li>
          <li>
           本司對以下特定情況收取額外費用；室外保險、樓面高於十呎、貨車(5.5 噸或以上)不能直達樓宇大門、長路程(平台轉運)、搬運梯級、偏遠地區、指定程序用料、
指定施工方法、特定時段工作、居住中、不充足工作空間、超越階級及無水電鮮風裝置…等，客戶請於報價階段註明(如有)以上涉及之項目，以免不必要的爭議。
          </li>
          <li>
            惠付方式本司專戶香港恆生銀行名: WING FAT DESIGN CONTRACTING LIMITED 賬戶號碼 NO. 212-372015-001，請客戶提供”繳付入賬證明”傳真到: (852)24799753 及
後經確認並發出”本司收據”為實，為保障客戶利益建議以”劃線支票或銀行入賬”繳付款項。或以網上銀行轉數快辦理，帳戶為 sales@wingfatdesign.com
          </li>
          <li>
            惠顧每單工程或傢俬項目達指定金額二萬元以上，本司提供免費(如有)基本運輸及安裝服務。
          </li>
          <li>
            銷售憑據內所有產品、規格或服務收費也涉及”最少訂貨量或生產數量之內”，本司會以”固定金額”實數收取，如超越生產數量或更改規格客戶需繳付差額。
          </li>
        </ul>
      </div>
      <div class="notice-box">
        <h4>自購配備</h4>
        <ul class="dashed">
          <li>
            除列明外，各項目只包括基本服務或本公司指定施工方法，並不包含用料或設備裝置。(如:建材飾面、磚瓦、牆紙、潔具、電器、床褥、燈飾、窗簾等) 如涉及個
人資料(例:物業管業、訊號及煤氣…等)，基於私隱問題，客戶請自行辦理跟進相關之申請預約至完成確認。同時也需注意客戶自行選購物料及設備質量，將會直接
影響安裝或施工後外觀或效果。
          </li>
          <li>
            購買項目飾面建材或其配套品時，須注意本司對相關生產施工面積、接駁、種類及數量之限制，以避免本司向客戶收取額外施工費用。(如:特大型、馬賽克瓷磚等)
          </li>
          <li>
            除經本司代購指定項目或條款註明外，客戶自備物品或服務本司不給予損耗換算、配套測試、配件、合適安裝、驗收、繳款、保險、運輸及預約監工之服務，建議
客戶先向自售產品及服務供應商了解詳情及親身跟進。
          </li>
          <li>
            項目不提供產品物料(如瓷磚、潔具、浴室配件、水龍頭、門較及鎖、門框底板、冷氣、窗簾、燈具等)及第三者責任保險或水火險並不包括本合約內。 (除註明外)，
請客戶提供充足自備產品物料，如不幸遇到品質、斷貨、批次、計算、損耗及送貨日等誤差或安裝等問題，由客戶一方承擔有關之損失包括附加項目及時間。施工
中若有新增工程或第三方工程，需按照目前施工時間安排進程，完工時間將按新增工程或第三方工程訂明時間完成，同時原本預計完工日期將視乎工程所需時間
自動延後。本司並不包括清理由第三方商戶衍生工程垃圾或執修由他們引致工程問題，也不會參與第三方工程承辦商任何洽商、訂造方案或安裝，除註有。
          </li>
          <li>
            客戶自備材料安裝並由本司提供慣常安裝服務，其安裝效果或成效不保證與材料供應商標準一致。任何情況下不會賠償自備材料損失，並需支付安裝材料人工費。
          </li>
        </ul>
      </div>

      <div class="notice-box">
        <h4>文件及圖紙</h4>
        <ul class="dashed">
          <li>
            本司為二級小型工程註冊承辦商，可辦理向”屋宇署”呈報 II、III 級別、小型工程計劃”項目申請。(不包括額外 I 級申請，客戶需給予” 小型工程計劃”申請程
序及施工標準之延誤時間)，II 級呈報需在施工前 14 天呈報開工，完工後 14 天內呈報完工申請。III 級呈報需完工後 14 天內呈報。
          </li>
          <li>
            本司之產品及服務有特定之規格，如客戶對產品或服務有任何特定的要求(如工藝或驗收要求)，請於簽署文件前提出，以免收取額外的費用及時間。
          </li>
          <li>
          惠顧之訂造或服務項目客戶需配合本司於生產前的”十個工作天”或之前確認簽署生產圖文；並同時提交相關之自購物品(如有)。本司訂造項目(除註明外)分別為
實地生產約二十個工作天或廠房生產約三十個工作天內完(不包括運輸及安裝日期)，若工程地址未能提供合適的環境進行安裝，安裝日期須延後。(如安裝日期受
工程進度影響將順延，恕不另行通知。) 所有已經完成付款項目，可憑總額(包括銷售發票)收據申領完工文件或相片(文件製作需時約 7 個工作天)。
          </li>
          <li>
            本司會向惠顧客戶發出手機信息通知，客戶需配合相關之信息內容，如已處理或無關項目不需理會該通知信息，本司不會以訊息索取個人資料及作任何回覆。
          </li>
          <li>
            設計圖或圖片只供客戶參考，生產均以客戶確認簽署＂銷售憑據及施工圖文(工程雙向簡介施工方案)”作生產依據，請客戶覆核傢電面積及擺放後確認為實，限制
設計圖及生產圖文客戶於確認簽署日前可改動一次及後改動另作收費，在不影響產品外觀下本司履行生產並保留 20%內修改結構或內籠權利，不另行通知。若因
修改後直接影響產品外觀，將會通知客戶洽商另外施工方案。客戶注意若提供圖文予本司承造，所有顏色，款色及尺寸均以本司施工圖及色版作生產依歸。
          </li>
          <li>
            客戶如欲改動銷售憑據、服務及生產圖文，可於簽署確認後的二十四小時內帶同憑據正本親臨本公司辦理，逾期客戶需繳付項目金額的 50%為改動手續費及(如有)
連帶的附加項目收費，經生產或進行中項目本司不設更改或退換。
          </li>
        </ul>
      </div>
      <div class="notice-box">
        <h4>常見慣常施工說明</h4>
        <ul class="dashed">
          <li>
            傢俬訂造”活動或嵌入式”傢俬項目(除註明)有高度提供高身櫃高 96 吋內、飾櫃高 78 吋內、半腰櫃高 42 吋、吊櫃高 25 吋、地櫃高 30 吋內及櫃深 24 吋內計算收
費，超越限制呎吋客戶需繳付額外附加費用。惠顧訂造產品或服務，客戶需承擔天然物料或手工可能產生之產色、紋理、組裝及呎吋等之誤差，本公司不設退換或
建議客戶可選購市場現貨成品。
</li>
          <li>
            傢俬均以 6/8”吋厚木材夾板或中纖維板作傢俬主體結構，裝飾面材料(收費不一)以”木皮/啞面油漆/防花板或膠板”生產，本公司提供合格基礎五金組件”抽屜三
節走珠側路軌、合金門較…等。若以膠板飾面訂造的傢俬，當膠板與膠板接駁位置均會出現膠板厚度原裝色(或稱黑邊)，此為正常情況。
          </li>
          <li>
          所有安裝服務或生產項目的工藝、接駁位或門縫尺寸(包括傢俬訂造項目)，將以平水及企水作依歸，最終將儘量控制不大於 6mm 誤差值。(除註有)
          </li>
          <li>
            傢俬項目非實地生產(除註有)，由國內工場生產及實地技工組裝，如轉為實地木匠施工，客戶需另支付項目金額的 60%提升項目費用，以及結構改動、延長生產期
及延後原定的預計完工日期。
          </li>
          <li>
            裝置更換水管及電力項目以現存主位置(水總閘掣、電視天線、電話入線或電箱原裝位)後施工不設改動(除註有)藏入牆裝置或管類有可能受阻而改動位置或以外露
安裝方式，管類藏入舖設以室內同層、地台為主及不設天花計算收費，舊有藏入牆裝置或管類不設拆除。本司只接受完整裝置電力之 WR1 或新電錶代辦申請。若
需呈報 WR1 需在工程展開前 14 天通知本司。工程一旦展開後或只做加改電力裝置工程，將不能簽署及呈報 WR1。暗喉定義為完成飾面後不能看見，不論該喉管
是否藏牆。所有水喉，電喉及煤氣喉(暗喉)新造或改位，本公司將會以相片作記錄，完工後將會把記錄轉存予客戶。轉存後客戶需自行儲存，我們將不會代為儲存。
          </li>
          <li>
            清拆工程在指定範圍內(牆身或地台)拆除最表面一層物料，多於一層物料，將另議。清拆多於一層物料項目產生建築癈物處置費用，由客戶(除註有)一方負責。
          </li>
          <li>
            油漆工程內剷底批灰定義為剷除舊有菜膠+福粉底灰及重新新做由菜膠+福粉底灰，以重新構造牆身天花底料結構，若施工單位牆身面料結構並非菜膠+福粉底灰構
成或底料老化，將另議需重做批盪或紙巾灰。同時油漆只可依照已存在牆身批盪新造底灰及修復裂痕牆身，工藝不包括拉直明暗角位置或拉平牆身表面，除註有。
          </li>
          <li>
           泥水新造地台為乾濕沙地台厚度不超過 50MM，因受制於天氣及磁磚質數，當超過總面積 20%懷疑是空芯磚時，將做 5 點測試，若出現 3 點以上中空，將會更換及
重鋪該件問題磁磚(不包磁磚)。(長條地磚或單邊總長超過 600MM 不在此限內)。牆身或地台鋪設磁磚方式將以橫向或直向方式及對齊方式排列。額外鋪設方式如斜
向或拼湊圖案鋪設將另議額外人工及時間。廚房、廁所地台或其他需要去水位置，將按施工現場環境承造。若客戶有特別做法，必須需於施工前向本司陳述說明。
          </li>
          <li>
            本司職員只提供以簡單測量工具(如:軟尺) 作出評估或量度尺寸，供客戶或第三方生產商(如:門行或磁磚公司等)作參考之用，本司並不就所提供之評估或量度尺寸
作任何賠償。如客戶須要更精確的評估或尺寸，建議客戶由相關項目承辦商或所屬專家以精準之儀器作測量或評估。
          </li>
        </ul>
      </div>
      <div class="notice-box">
        <h4>維修及保養</h4>
        <ul class="dashed">
          <li>
            本司產品或服務合一般成人或成人陪同使用(或生產商建議)，如發現異常請即停止使用並盡快通知本司(或代理商)進行維修服務。
          </li>
          <li>
            客戶憑本司總額收據享結構保養（不含人為 / 自然因素 / 損耗品），基本保養限 12 個月或 4 次維修（先到為準），起算日為餘款收據日期。
          </li>
          <li>
            銷售憑證內容涉及修改、維修、翻新等項目：客戶須知曉潛在風險，施工中可能產生附加收費；此類項目耐用性低於全新承造，尺寸、紋理或顏色或與現存存在誤
差。防漏修補、防水工程及五金配件相關項目，我司不提供保修，且不儲存材料用於後續保修。
          </li>
        </ul>
      </div>
      <div class="notice-box">
        <h4>更改或取消及保險</h4>
        <ul class="dashed">
          <li>
            施工中客戶如欲”取消、更改或終止”銷售憑據之交易訂金恕不退還，以及按產品或服務項目(取消折扣)以正價計算繳付階段之費用，本司並收取總額的額外 20%
金額為行政或設計費用。若涉及本司代客戶購買” 第三責任工程保險”，將即時中止所有保險、中止所有已代購產品及代安裝服務的保修服務。
          </li>
          <li>
           代購第三責任工程保險為期三個月內、樓齡 40 年以下、樓面高九呎內(不包室外)及受保險條款約束室內公眾第三者公眾責任保險，承坦保障最高賠償金額上限為五百萬元內，如保險賠償金額或條款超越上限由客戶一方承擔賠償或涉及訴訟費用，建議客戶因應個人需要或環境風險向專業人士於開工日前選購合適相關保險。
          </li>
          <li>
            本司已為屬下員工購買室內工程勞工保險。第三者保險不包括施工單位內水火險。若客戶自行購買任一保險，受保人需包含客戶、本司及施工單位管理公司名稱。
          </li>
        </ul>
      <b style="font-size: 0.65rem; top:-5px; position: relative;">本司產品、服務、備註及條款細則保留最終註解生產決定之權利，如有任何改動恕不另行通知。</b>
      </div>
    </b-card>
  </section>
</template>


<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BOverlay,
} from "bootstrap-vue";

export default {
  data() {
    return {};
  },
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BOverlay,
  },
};
</script>
<style lang="scss">
.notice-to-customers {
  *{
    color: black !important;;
  }
  margin-bottom:23px;
  .card{
    .card-body{
      padding-left: 60.48px;
      padding-right: 60.48px;
      // padding-left: 2rem;
      // padding-right: 2rem;
    }
    height:1100px;
  };
  h1 {
    font-size: 0.9rem;
    margin-bottom: 0rem;
    text-align: center;
  }
  .notice-box {
    margin-bottom: 0rem;
    b{
      font-size: 8.5px;
    }
    ul{
      margin-bottom: 0.13rem;
    }
    h4,
    li {
      text-align: left;
    }
    h4 {
      font-size: 0.65rem;
      margin-bottom:0px;
    }
    li {
      font-size: 0.58rem;
      padding-left:0.2rem;
      line-height: 1.37;
    }
  }
}
@media print {
  .notice-to-customers{
    .card{
      .card-body{
        padding-left: 0px;
        padding-right: 0px;
      }
    };
  }
}
</style>
